// The source's label (Metabase question number or "Google Sheet"), linked to
// the question or sheet tab so it opens in a new tab.
export default function SourceLink({ ds }: { ds: { source_type: string; source_identifier: string; source_url: string | null } }) {
  const label = ds.source_type === 'google_sheet' ? 'Google Sheet' : `Q#${ds.source_identifier}`
  if (!ds.source_url) return <>{label}</>
  return (
    <a href={ds.source_url} target="_blank" rel="noreferrer"
      className="text-link underline decoration-link/30 hover:decoration-link">
      {label}
    </a>
  )
}
